var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as StackBlur from 'stackblur-canvas';
import { canvasSetSmoothing, getCanvas2d, toBlob } from 'app/utils/canvas';
import { DefaultOpts, downscaleImage, getPixelateSizes } from './utils';
export const imagePixelate = (source, size, opts) => __awaiter(void 0, void 0, void 0, function* () {
    const { canvasProvider: provider, orientation = 1 /* ImageOrientation.up */, useBlur = false, blurRadius = DefaultOpts.defaultBlurRadius, } = opts;
    const { pixelateWidth, pixelateHeight, reorientMatrix, reorientImageWidth, reorientImageHeight, } = getPixelateSizes(size, orientation);
    // Step 1. downscale to pixelate
    let downscaledImage;
    let insets;
    let disposeDownscaledImage;
    try {
        const result = yield downscaleImage(source, {
            width: pixelateWidth,
            height: pixelateHeight,
        }, provider);
        insets = result.insets;
        downscaledImage = result.image;
        disposeDownscaledImage = result.dispose;
    }
    catch (error) {
        console.error(error);
    }
    // Step 2. stretch and blur
    let bytes;
    if (downscaledImage) {
        const canvas = provider.createCanvas(reorientImageWidth, reorientImageHeight);
        const ctx = getCanvas2d(canvas);
        canvasSetSmoothing(ctx, false);
        ctx.save();
        ctx.setTransform(reorientMatrix.a, reorientMatrix.b, reorientMatrix.c, reorientMatrix.d, 0, 0);
        ctx.drawImage(downscaledImage, 0, 0, downscaledImage.width, downscaledImage.height, 0, 0, reorientImageWidth, reorientImageHeight);
        ctx.restore();
        canvasSetSmoothing(ctx, true);
        // NOTE: try bluring before stretching
        if (useBlur) {
            StackBlur.canvasRGB(canvas, 0, 0, canvas.width, canvas.height, blurRadius !== null && blurRadius !== void 0 ? blurRadius : DefaultOpts.defaultBlurRadius);
        }
        try {
            bytes = yield toBlob(canvas, 'image/jpeg', 0.9);
        }
        catch (error) {
            console.error(error);
            bytes = undefined;
        }
        provider.disposeCanvas(canvas);
        disposeDownscaledImage === null || disposeDownscaledImage === void 0 ? void 0 : disposeDownscaledImage();
    }
    provider.dispose();
    return {
        bytes,
        insets,
        width: reorientImageWidth,
        height: reorientImageHeight,
    };
});
